import { useMatchMedia } from './useMatchMedia';
import { useTheme } from '../styling/hooks';

/**
 * It listens for breakpoint changes and returns current breakpoint name.
 * It is not necessary to pass any arguments if used inside <StyleProvider /> component.
 * @returns current breakpoint name based on screen size.
 */
export const useCurrentBreakpoint = (alternativeBreakpoints) => {
  const { breakpoints } = useTheme();
  const { up, names } = breakpoints || alternativeBreakpoints;

  const currentBreakpoint = names
    .slice()
    .reverse()
    .reduce((prev, bp) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const matched = useMatchMedia(up(bp));
      return matched && !prev ? bp : prev;
    }, null);

  return currentBreakpoint;
};
